/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryticketsmissing2Inputs */

const en_entryticketsmissing2 = /** @type {(inputs: Entryticketsmissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one ticket type.`)
};

const de_entryticketsmissing2 = /** @type {(inputs: Entryticketsmissing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg mindestens eine Ticketart an.`)
};

/**
* | output |
* | --- |
* | "Add at least one ticket type." |
*
* @param {Entryticketsmissing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryticketsmissing2 = /** @type {((inputs?: Entryticketsmissing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryticketsmissing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryticketsmissing2(inputs)
	return de_entryticketsmissing2(inputs)
});
export { entryticketsmissing2 as "entryTicketsMissing" }